import { render, staticRenderFns } from "./TinycCinicManagement.vue?vue&type=template&id=babda990&scoped=true"
import script from "./TinycCinicManagement.vue?vue&type=script&lang=js"
export * from "./TinycCinicManagement.vue?vue&type=script&lang=js"
import style0 from "./TinycCinicManagement.vue?vue&type=style&index=0&id=babda990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babda990",
  null
  
)

export default component.exports